import React from 'react'
import GlobalModal from '../Global/GlobalModal'
import DynamicForm from './DynamicForm'
import { DynamicFormDocumentFlexible } from '@/interfaces/common/prismicDynamicForm'

type Props = {
  open: boolean
  onClose: () => void
  formData: DynamicFormDocumentFlexible
  orderNumber?: string
  fileUploadConfig?: {
    entityType: string
  }
}

const DynamicFormModal: React.FC<Props> = ({
  open,
  onClose,
  formData,
  orderNumber,
  fileUploadConfig,
}) => {
  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      customClass={'dynamic-form-modal'}
      modalTitle={{ data: formData?.data?.form_title, defaultText: 'Form' }}
    >
      <DynamicForm
        formData={formData}
        orderNumber={orderNumber}
        fileUploadConfig={fileUploadConfig}
      />
    </GlobalModal>
  )
}

export default DynamicFormModal
